// Over a surface, Tessra's blue variant would not hold white text; the dark theme takes its own token.
export const NEW_SEGMENT_CHIP = 'bg-blue-600 text-white dark:bg-badge-blue [&_svg]:text-current';
